import { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const Logo = ({ size = 'medium', showText = true }) => {
  const [logoUrl, setLogoUrl] = useState(null);

  useEffect(() => {
    fetchLogo();
  }, []);

  const fetchLogo = async () => {
    try {
      const response = await axios.get(`${API}/branding/logo`);
      if (response.data.filename) {
        setLogoUrl(`/${response.data.filename}?t=${Date.now()}`);
      }
    } catch (error) {
      console.error('Error fetching logo:', error);
    }
  };

  const sizeClasses = {
    small: 'h-8',
    medium: 'h-16',
    large: 'h-20',
    hero: 'h-24'
  };

  const textSizeClasses = {
    small: 'text-lg',
    medium: 'text-2xl',
    large: 'text-3xl',
    hero: 'text-4xl'
  };

  if (logoUrl) {
    return (
      <div className="logo-wrapper flex items-center gap-3">
        <img 
          src={logoUrl} 
          alt="Debatefy" 
          className={`logo-image ${sizeClasses[size]} w-auto object-contain`}
        />
        {showText && (
          <span className={`logo-brand-text font-bold ${textSizeClasses[size]}`}>
            debatefy
          </span>
        )}
      </div>
    );
  }

  // Default logo (letter D)
  return (
    <div className="logo-wrapper flex items-center gap-3">
      <div className={`logo-circle-default ${sizeClasses[size]} aspect-square rounded-full bg-white/20 backdrop-blur-md flex items-center justify-center border-2 border-white/30`}>
        <span className={`logo-text-default font-bold text-white ${textSizeClasses[size]}`}>
          D
        </span>
      </div>
      {showText && (
        <span className={`logo-brand-text font-bold ${textSizeClasses[size]}`}>
          debatefy
        </span>
      )}
    </div>
  );
};

export default Logo;
